import React from 'react'

import { DeleteButton } from '@app/lib/components/ModernChat/DeleteButton'

import { EditButton } from '../EditButton'
import { IMessage } from '../index'

type Props = {
  onStartEdit?: React.MouseEventHandler
  deleteMessage?: (messageId: number) => void
  messageId?: IMessage['id']
}

export const MessageContentActions = ({ onStartEdit, deleteMessage, messageId }: Props) => {
  if (!onStartEdit && !deleteMessage) return null

  return (
    <div className={'modern-chat-message-content__actions'}>
      {deleteMessage && messageId && (
        <DeleteButton deleteMessage={deleteMessage} messageId={messageId} />
      )}
      {onStartEdit && <EditButton onStartEdit={onStartEdit} />}
    </div>
  )
}
